
/* Observers: Lazy Background Images*/
  window.addEventListener('DOMContentLoaded', (event) => {

	/* all elements with background images that should be lazy loaded*/
	const lazyImages = document.querySelectorAll('.lazybg');

	/* options for the observer*/
	const backgroundOptions = {
	  threshold: 0,
	  rootMargin: "0px 0px 50px 0px"
	};

	/* the observer*/
	const imageObserver = new IntersectionObserver((entries, imageObserver) => {
	  entries.forEach(entry => {
		if (entry.isIntersecting) {
		  showImageBackground(entry.target);
		  imageObserver.unobserve(entry.target);
		}
	  });
	}, backgroundOptions);


	/* observe each image*/
	lazyImages.forEach(image => {
	  imageObserver.observe(image);
	});

	/* show background image*/
	function showImageBackground(node) {
	  node.classList.remove('lazybg');
	}
  });
   
  /*Observers: Lazy Videos*/
  document.addEventListener("DOMContentLoaded", function() {
	var lazyVideos = [].slice.call(document.querySelectorAll(".lazyvid"));
	if ("IntersectionObserver" in window) {
	  var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
		entries.forEach(function(video) {
		  if (video.isIntersecting) {
			for (var source in video.target.children) {
			  var videoSource = video.target.children[source];
			  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				videoSource.src = videoSource.dataset.src
			  }
			}
			video.target.load();
			video.target.classList.remove(".lazyvid");
			lazyVideoObserver.unobserve(video.target)
		  }
		})
	  });
	  lazyVideos.forEach(function(lazyVideo) {
		lazyVideoObserver.observe(lazyVideo)
	  })
	}
  });
  
